import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
import Button from '../Button';
import CloseButton from '../CloseButton';
import { APPEARANCE, dataHooks, LAYOUT, SIZE, BORDER } from './constants';
import { classes, st } from './SectionHelper.st.css.js';
import { WixDesignSystemContext } from '../WixDesignSystemProvider/context';
const SectionHelper = ({ dataHook, showCloseButton = false, onClose, onAction, actionText, appearance = APPEARANCE.Warning, title, size = SIZE.Medium, fullWidth = false, children, layout = LAYOUT.Vertical, border = BORDER.Standard, }) => {
    const isExperimentalDark = appearance === APPEARANCE.ExperimentalDark;
    const { newColorsBranding } = useContext(WixDesignSystemContext);
    return (React.createElement("div", { "data-hook": dataHook, "data-appearance": appearance, className: st(classes.root, {
            appearance,
            withCloseBtn: showCloseButton,
            withTitle: !!title,
            fullWidth,
            size,
            newColorsBranding,
            layout,
            border,
        }) },
        showCloseButton && (React.createElement("div", { className: st(classes.close, { size }) },
            React.createElement(CloseButton, { dataHook: dataHooks.closeButton, size: "medium", skin: isExperimentalDark ? 'light' : 'dark', onClick: onClose }))),
        React.createElement("div", { className: classes.content },
            title && (React.createElement("div", { className: classes.title },
                React.createElement(Text, { light: isExperimentalDark, dataHook: dataHooks.title, size: "small", weight: "bold" }, title))),
            React.createElement(Text, { size: "small", light: isExperimentalDark }, children)),
        actionText && (React.createElement("div", null,
            React.createElement(Button, { size: size === 'small' ? 'tiny' : 'small', skin: isExperimentalDark ? 'standard' : 'dark', priority: isExperimentalDark ? 'primary' : 'secondary', onClick: onAction, dataHook: dataHooks.actionButton }, actionText)))));
};
SectionHelper.displayName = 'SectionHelper';
SectionHelper.propTypes = {
    dataHook: PropTypes.string,
    appearance: PropTypes.oneOf([
        'warning',
        'standard',
        'danger',
        'success',
        'premium',
        'preview',
        'experimentalDark',
    ]),
    title: PropTypes.node,
    size: PropTypes.oneOf(['small', 'medium']),
    showCloseButton: PropTypes.bool,
    onClose: PropTypes.func,
    onAction: PropTypes.func,
    actionText: PropTypes.string,
    children: PropTypes.node,
    fullWidth: PropTypes.bool,
    layout: PropTypes.oneOf(['vertical', 'horizontal']),
    border: PropTypes.oneOf(['standard', 'topBottom']),
};
export default SectionHelper;
//# sourceMappingURL=SectionHelper.js.map